import * as React from "react";

export function NightModeIcon(): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="14"
      viewBox="0 0 13 14"
    >
      <path d="M4.8696719,-5.90749671e-12 C4.11151134,1.11550062 3.66845214,2.46244109 3.66845214,3.91286359 C3.66845214,7.76202509 6.78881407,10.882387 10.6379756,10.882387 C11.369744,10.882387 12.0751721,10.7696101 12.7378271,10.5604889 C11.4839653,12.4053271 9.36826243,13.6171487 6.96952343,13.6171487 C3.12036192,13.6171487 0,10.4967868 0,6.6476253 C0,3.53023227 2.0467077,0.890873439 4.8696719,-2.24256724e-12 Z" />
    </svg>
  );
}
